import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import CarouselItem from "../../../SHARED/components/carousel/carouselitem.component";
import { getRecommendedMovies } from "../../../SHARED/actions/movies.actions";

class SerialsRecommendedForYou extends Component {

    componentWillMount(){
        const movieId = this.props.match.params.id;
        this.props.getRecommendedMovies(movieId);
    }

    getSerials = () => {
        return this.props.recommendedMovies.map((serial, i) => {
            return (
                <div className="col-lg-2 item-recommended" key={i}>
                    <CarouselItem card={serial} component={"recommended"} />
                </div>
            )
        })
    };

    render() {
        return (
            <div className="serials-recommended-for-you">
                <div className="row no-gutters">
                    { this.getSerials() }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    recommendedMovies: state.movies.recommendedMovies
});
export default withRouter(connect(mapStateToProps, {getRecommendedMovies})(SerialsRecommendedForYou));






// WEBPACK FOOTER //
// ./src/FO/components/serialsrecommendedforyou/serialsrecommendedforyou.component.js